import { render, staticRenderFns } from "./SelWorkerTeam.vue?vue&type=template&id=95a4bf7a&"
import script from "./SelWorkerTeam.vue?vue&type=script&lang=js&"
export * from "./SelWorkerTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports